import type { EnumTypeValue } from "@/shared/types/enum";

export const TVVBestelStatus = {
    Aangevraagd: "Aangevraagd",
    Gedeeltelijk: "Gedeeltelijk",
    Volledig: "Volledig",
    StopAangevraagd: "StopAangevraagd",
    Gestopt: "Gestopt",
} as const;
export type TVVBestelStatus = EnumTypeValue<typeof TVVBestelStatus>;

export const Reisperiode = {
    Dal: "Dal",
    Ochtendspits: "Ochtendspits",
    Avondspits: "Avondspits",
    Superdal: "Superdal",
    Zaterdag: "Zaterdag",
    Zondag: "Zondag",
    Handmatig: "Handmatig",
} as const;
export type Reisperiode = EnumTypeValue<typeof Reisperiode>;

export const Routesoort = {
    Stop: "Stop",
    Snel: "Snel",
    Overig: "Overig",
    Pendel: "Pendel",
} as const;
export type Routesoort = EnumTypeValue<typeof Routesoort>;

export const Voertuigsoort = {
    Bus: "Bus",
    OVBus: "OVBus",
    OVTram: "OVTram",
    OVMetro: "OVMetro",
    Taxibus: "Taxibus",
} as const;
export type Voertuigsoort = EnumTypeValue<typeof Voertuigsoort>;

export const VoertuigsoortDisplay = {
    Bus: "Touringcar",
    OVBus: "OV Bus",
    OVTram: "OV Tram",
    OVMetro: "OV Metro",
    Taxibus: "Taxibus",
} as const satisfies Record<Voertuigsoort, string>;

export const RoutesoortDisplay = {
    Stop: "Stopbus",
    Snel: "Snelbus",
    Overig: "Overig",
    Pendel: "Pendelbus",
} as const satisfies Record<Routesoort, string>;

export const Organisatie = {
    DeWit: "DeWit",
    Transvision: "Transvision",
    GVB: "GVB",
    HTM: "HTM",
    RET: "RET",
    U_OV: "U_OV",
    TestBus: "TestBus",
} as const;
export type Organisatie = EnumTypeValue<typeof Organisatie>;

export const OrganisatieDisplay = {
    DeWit: "De Wit",
    Transvision: "Transvision",
    GVB: "GVB",
    HTM: "HTM",
    RET: "RET",
    U_OV: "U-OV",
    TestBus: "TestBus",
} as const satisfies Record<Organisatie, string>;
